module.exports = __webpack_public_path__ + "img/gekuehlt.fcccab9f.svg";